import { EventDispatcher } from '../EventDispatcher';
import { Viewer } from '../viewer/viewer';
import { PointoramaSurface } from './PointoramaSurface';
import { Utils } from '../utils';

export class SelectionTool extends EventDispatcher {
  viewer: Viewer;
  active: boolean;

  constructor(viewer: Viewer) {
    super();

    this.active = true;

    this.viewer = viewer;
  }

  activate() {
    this.active = true;
    this.viewer.setControls(this.viewer.orbitControls);
  }

  deactivate() {
    this.active = false;
  }

  onMouseMove() {
    if (!this.active) return;

    const measure = this.viewer.inputHandler.getHoveredMeasure() || this.viewer.inputHandler.getHoveredPlane() || this.viewer.inputHandler.getHoveredSurface() || this.viewer.inputHandler.getHoveredBox();

    if (this.viewer.orbitControls.forcedMode) return; // do not override forced mode icons
    if (measure) {
      Utils.changeCursor('pointer');
    } else {
      Utils.changeCursor('default');
    }
  }

  onClick(ctrlDown: boolean) {
    if (!this.active) return;

    // Check for surface first - surfaces are groups, not annotations
    const hoveredSurface = this.viewer.inputHandler.getHoveredSurface() as PointoramaSurface | null;
    if (hoveredSurface) {
      this.viewer.scene.dispatchEvent({
        type: 'select_group',
        value: { groupIdentifier: hoveredSurface.identifier },
      });
      return;
    }

    const measure = this.viewer.inputHandler.getHoveredMeasure() || this.viewer.inputHandler.getHoveredPlane() || this.viewer.inputHandler.getHoveredBox();

    this.viewer.scene.dispatchEvent({
      type: 'measurement_select',
      value: { measure, isCtrl: ctrlDown },
    });
  }

  onTap() {
    if (!this.active) return;

    // Check for surface first - surfaces are groups, not annotations
    const hoveredSurface = this.viewer.inputHandler.getHoveredSurface() as PointoramaSurface | null;
    if (hoveredSurface) {
      this.viewer.scene.dispatchEvent({
        type: 'select_group',
        value: { groupIdentifier: hoveredSurface.identifier },
      });
      return;
    }

    const measure = this.viewer.inputHandler.getTouchedMeasure() || this.viewer.inputHandler.getHoveredPlane() || this.viewer.inputHandler.getHoveredBox();

    this.viewer.scene.dispatchEvent({
      type: 'measurement_select',
      value: { measure, isCtrl: false },
    });
  }
}
